import { Box } from "@mui/material";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { deleteSectionAsync, fetchMyPlanDetailAsync } from "../MyPlanDetails/MyPlanDetails.slice";
import { responseTypes } from "utils/Types";

interface Prop {
  openDeleteDialog: boolean;
  setOpenDeleteDialog: React.Dispatch<React.SetStateAction<boolean>>;
  sectionId: number;
  cardsCount: number;
}

export default function DeleteSection(props: Prop) {
  const dispatch = useAppDispatch();
  const { openDeleteDialog, setOpenDeleteDialog, sectionId, cardsCount } = props;
  const selectedMyPlanDetail: any = useAppSelector((state) => state.myPlanDetails.myPlanDetails);

  const deleteSection = async () => {
    const prop = {
      planId: selectedMyPlanDetail.id,
      sectionId
    };
    const res = await dispatch(deleteSectionAsync(prop));
    if (res?.payload?.status === responseTypes.no_content) {
      await dispatch(fetchMyPlanDetailAsync({ id: prop.planId, includePropertyInfo: true }));
    }

    setOpenDeleteDialog(false);
  };

  const handleCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  return (
    <>
      {openDeleteDialog && (
        <DialogFormation
          title="Delete Section"
          openDialog={openDeleteDialog}
          handleClose={handleCloseDialog}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button variant="secondary" label="Cancel" onClick={handleCloseDialog} width="25%" />
              <Button label="Proceed" width="25%" onClick={deleteSection} />
            </div>
          }
        >
          <div className="vertical-center display-col">
            {cardsCount > 0
              ? `This will permanently delete ${cardsCount} actions with the Section.`
              : ` This will permanently delete the Section.`}
            <Box>Do you wish to proceed?</Box>
          </div>
        </DialogFormation>
      )}
    </>
  );
}
